import React from "react";
import styles from "./SelectedChatContainer.module.scss";
import { ChevronLeftIcon } from "../../assets/icons/ChevronLeftIcon";
import { messageDate } from "../../utils/methods/validateMessageDate";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

export const SelectedChatContainer = ({
  handleGoBack,
  name,
  loading,
  itemUrl,
}) => {
  const {
    activeTelegramDialog,
    activeWhatsappDialog,
    activeAvitoDialog,
    activeVkDialog,
  } = useSelector((state) => state?.dialog);

  const chatHistoryTg = activeTelegramDialog?.histories;
  const chatHistoryWa = activeWhatsappDialog?.histories;
  const chatHistoryAvito = activeAvitoDialog?.histories;
  const chatHistoryVk = activeVkDialog?.histories;

  const MessageUser = ({ data }) => {
    return (
      <div className={styles.messageIncomeContainer}>
        <div className={styles.messageIncome}>{data.content}</div>
        <div className={styles.date}>{messageDate(data.date, true)}</div>
      </div>
    );
  };
  const MessageBot = ({ data }) => {
    return (
      <div className={styles.messageOutcomeContainer}>
        <div className={styles.messageOutcome}>{data.content}</div>
        <div className={styles.date}>{messageDate(data.date, true)}</div>
      </div>
    );
  };

  const LoadingContainer = () => {
    return (
      <div className={styles.loadingContainer}>
        <ClipLoader color="#575757" />
        <div className={styles.loadingTitle}>Загрузка</div>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerContainer} onClick={handleGoBack}>
          <div className={styles.iconBack}>
            <ChevronLeftIcon width={14} height={22} fill={"#575757"} />
          </div>
          <div className={styles.chatName}>{name}</div>
        </div>
        {activeAvitoDialog && itemUrl && (
          <div className={styles.linkContainer}>
            По объявлению:
            <br />
            <a
              className={styles.link}
              href={itemUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {itemUrl}
            </a>
          </div>
        )}
        {activeVkDialog && itemUrl && (
          <div className={styles.linkContainer}>
            Ссылка на профиль:
            <br />
            <a
              className={styles.link}
              href={itemUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {itemUrl}
            </a>
          </div>
        )}
      </div>
      <div className={styles.messagesWrapper}>
        {activeTelegramDialog && (
          <div
            className={`${styles.messagesContainer} ${
              !chatHistoryTg || chatHistoryTg?.length === 0
                ? styles.emptyHistoryContainer
                : ""
            }`}
          >
            {loading ? (
              <LoadingContainer />
            ) : chatHistoryTg?.length > 0 ? (
              chatHistoryTg?.map((item, index) => {
                if (item.role === "user") {
                  return <MessageUser key={`msg-user-${index}`} data={item} />;
                } else
                  return <MessageBot key={`msg-bot-${index}`} data={item} />;
              })
            ) : (
              <div className={styles.emptyHistory}>
                Ассистент еще не общался с этим пользователем
              </div>
            )}
          </div>
        )}
        {activeWhatsappDialog && (
          <div
            className={`${styles.messagesContainer} ${
              !chatHistoryWa || chatHistoryWa?.length === 0
                ? styles.emptyHistoryContainer
                : ""
            }`}
          >
            {loading ? (
              <LoadingContainer />
            ) : chatHistoryWa?.length > 0 ? (
              chatHistoryWa?.map((item, index) => {
                if (item.role === "user") {
                  return <MessageUser key={`msg-user-${index}`} data={item} />;
                } else
                  return <MessageBot key={`msg-bot-${index}`} data={item} />;
              })
            ) : (
              <div className={styles.emptyHistory}>
                Ассистент еще не общался с этим пользователем
              </div>
            )}
          </div>
        )}
        {activeAvitoDialog && (
          <div
            className={`${styles.messagesContainer} ${
              !chatHistoryAvito || chatHistoryAvito?.length === 0
                ? styles.emptyHistoryContainer
                : ""
            }`}
          >
            {loading ? (
              <LoadingContainer />
            ) : chatHistoryAvito?.length > 0 ? (
              chatHistoryAvito?.map((item, index) => {
                if (item.role === "user") {
                  return <MessageUser key={`msg-user-${index}`} data={item} />;
                } else
                  return <MessageBot key={`msg-bot-${index}`} data={item} />;
              })
            ) : (
              <div className={styles.emptyHistory}>
                Ассистент еще не общался с этим пользователем
              </div>
            )}
          </div>
        )}
        {activeVkDialog && (
          <div
            className={`${styles.messagesContainer} ${
              !chatHistoryVk || chatHistoryVk?.length === 0
                ? styles.emptyHistoryContainer
                : ""
            }`}
          >
            {loading ? (
              <LoadingContainer />
            ) : chatHistoryVk?.length > 0 ? (
              chatHistoryVk?.map((item, index) => {
                if (item.role === "user") {
                  return <MessageUser key={`msg-user-${index}`} data={item} />;
                } else
                  return <MessageBot key={`msg-bot-${index}`} data={item} />;
              })
            ) : (
              <div className={styles.emptyHistory}>
                Ассистент еще не общался с этим пользователем
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
